import { useEffect, useState } from "react";
import { Download, Share, PlusSquare } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

let deferred = null;
const listeners = new Set();
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    listeners.forEach((l) => l());
  });
  window.addEventListener("appinstalled", () => { deferred = null; listeners.forEach((l) => l()); });
}

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const InstallButton = ({ className = "", testid = "install-app-btn", label = "Instalar app" }) => {
  const [, force] = useState(0);
  const [help, setHelp] = useState(false);
  useEffect(() => {
    const l = () => force((x) => x + 1);
    listeners.add(l);
    return () => listeners.delete(l);
  }, []);
  if (isStandalone()) return null;
  const click = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      deferred = null;
      force((x) => x + 1);
    } else setHelp(true);
  };
  return (
    <>
      <button data-testid={testid} onClick={click} className={className || "btn-ghost flex items-center gap-1.5"}>
        <Download className="h-4 w-4" />{label}
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent className="border-[#232B3E] bg-[#121722] sm:max-w-sm" data-testid="install-help-dialog">
          <DialogHeader><DialogTitle className="h-display text-3xl">Instalar o app</DialogTitle></DialogHeader>
          {isIOS() ? (
            <ol className="space-y-3 text-sm text-[#cbd5e1]">
              <li className="flex items-center gap-2">1. Abra este site no <b>Safari</b></li>
              <li className="flex items-center gap-2">2. Toque em <Share className="h-4 w-4 text-[#E4F222]" /> <b>Compartilhar</b></li>
              <li className="flex items-center gap-2">3. Escolha <PlusSquare className="h-4 w-4 text-[#E4F222]" /> <b>Adicionar à Tela de Início</b></li>
            </ol>
          ) : (
            <ol className="space-y-3 text-sm text-[#cbd5e1]">
              <li>1. Abra este site no <b>Chrome</b></li>
              <li>2. Toque no menu <b>⋮</b> (canto superior)</li>
              <li>3. Escolha <b>Instalar app</b> ou <b>Adicionar à tela inicial</b></li>
            </ol>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
